import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
    const isMobileFirstLoad = window.innerWidth < 768;

    const itemsBlockVideoDetails = document.querySelectorAll('.mksun-video-details__item');

    itemsBlockVideoDetails.forEach((item) => {
        const tlBlockVideoDetails = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: 'center bottom'
            }
        });

        if (!isMobileFirstLoad) {
            const titleBlockVideoDetails = new SplitText(
                item.querySelectorAll('.timeline-text-reveal:not(.timeline-text-reveal--lines)'),
                {
                    type: 'words'
                }
            );

            const linesBlockVideoDetails = new SplitText(
                item.querySelectorAll('.timeline-text-reveal--lines'),
                {
                    type: 'lines'
                }
            );

            const buttons = item.querySelectorAll('.btn-ctn .btn');

            console.log(buttons);

            tlBlockVideoDetails.from(
                titleBlockVideoDetails.words,
                {
                    y: '100%',
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power1.out',
                    stagger: 0.1
                },
                '<'
            );

            tlBlockVideoDetails.from(
                linesBlockVideoDetails.lines,
                {
                    y: '100%',
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power1.out',
                    stagger: 0.1
                },
                '<'
            );

            tlBlockVideoDetails.fromTo(
                buttons,
                {
                    y: 64,
                    opacity: 0,
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: 0.5,
                    ease: 'power1.out',
                    stagger: 0.1,
                },
                "<"
            );
        }
    });

    /*
    const tlCardsVideo = gsap.timeline({
      scrollTrigger: {
          trigger: '.mksun-cards-video',
      }
    });

    const titleCardsVideo = new SplitText('.mksun-cards-video .timeline-text-reveal', {
      types: 'lines,words,chars',
    })

    tlCardsVideo.from(titleCardsVideo.words, {
      y: '100%', opacity: 0, duration: 0.5, ease: 'power1.out', stagger: 0.1,
    })

    tlCardsVideo.from('.mksun-cards-video .mksun-card-video', {
      stagger: {
          amount: .5, onStart: function () {
              gsap.to(this.targets()[0].querySelectorAll(".mksun-card-video__bg"), {
                  width: "100%", opacity: 1, duration: .5, ease: 'power1.out',
              })
          }, onComplete: function () {
              gsap.to(this.targets()[0].querySelectorAll(".block-reveal *"), {
                  opacity: 1, translateY: 0, duration: .5, ease: 'power1.out',
              })

          }
      },
      onComplete: () => {
          callBackCardAnimation('.mksun-card-video')
      }
    })
    */
});